import { Grid as BaseGrid, styled } from '@mui/material'

export const Grid = styled(BaseGrid)`
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  width: 100%;
`

export const ImgOnboarding01 = styled('img')`
  height: 170px;
  width: 200px;
`

export const Root = styled('div')`
  width: 100%;
`

export const Row = styled('div')`
  text-align: center;
  width: 100%;
`

export const DetailWrapper = styled('div')`
  margin: 24px auto 0;
  max-width: 640px;
  text-align: left;
  width: 100%;
`

export const DetailTable = styled('table')`
  border: 1px solid #d8dde6;
  border-collapse: collapse;
  border-radius: 8px;
  margin: 0 0 24px;
  overflow: hidden;
  width: 100%;

  tbody tr:last-child td {
    border-bottom: none;
  }
`

export const DetailCaption = styled('th')`
  background-color: #f4f6f9;
  border-bottom: 1px solid #d8dde6;
  color: #1c2331;
  font-size: 16px;
  font-weight: 700;
  padding: 12px 16px;
  text-align: left;
`

export const DetailLabel = styled('td')`
  border-bottom: 1px solid #d8dde6;
  color: #1c2331;
  font-size: 14px;
  padding: 12px 16px;
  width: 50%;
`

export const DetailValue = styled('td')`
  border-bottom: 1px solid #d8dde6;
  color: #1c2331;
  font-size: 14px;
  font-weight: 700;
  padding: 12px 16px;
  text-align: right;
  width: 50%;
`

export const ButtonsRow = styled('div')`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 32px 0 8px;
  width: 100%;
`
